import type { PoiHistoryEvent, PoiHistoryEventType } from '@/api/poiHistoryApi';

/**
 * User-facing timeline titles per event type. Rendered uppercase by the event card
 * ("NO DIG® NEW LEAK"), matching the "No Dig® Repairs" trademark styling used by the
 * Filters and Download panels. Titles are frontend-owned (the API sends only the
 * eventType wire value) so copy changes never touch the API contract.
 */
export const POI_HISTORY_EVENT_TITLES: Record<PoiHistoryEventType, string> = {
    poi_assessment: 'Assessment',
    nodig_leak: 'No Dig® New Leak',
    nodig_repair: 'No Dig® Repair',
    nodig_recheck: 'No Dig® Recheck',
};

/**
 * Title for a specific event. A `poi_assessment` whose outcome confirmed a leak is the
 * "New Leak" lifecycle moment; other assessment outcomes (No Leak Found, Inconclusive,
 * Already Marked Up, Unable to Check) keep the generic "Assessment" title with the
 * outcome shown separately via `summary`. The two summary values checked here are the
 * server's labels for a confirmed leak (repaired or not) — keep in sync with the
 * backend's ToAssessmentSummary.
 */
export function getPoiHistoryEventTitle(event: Pick<PoiHistoryEvent, 'eventType' | 'summary'>): string {
    if (event.eventType === 'poi_assessment' && (event.summary === 'Leak Found' || event.summary === 'Leak Repaired')) {
        return 'New Leak';
    }
    return POI_HISTORY_EVENT_TITLES[event.eventType];
}
